// extracted by mini-css-extract-plugin
export var cont = "products-module--cont--f63cc";
export var images = "products-module--images--db7e0";
export var img_2 = "products-module--img_2--74f86";
export var infos = "products-module--infos--320a4";
export var prods = "products-module--prods--a6392";
export var qsizes = "products-module--qsizes--7109b";
export var tile = "products-module--tile--94f6a";
export var tile_link = "products-module--tile_link--d5964";
export var tiles = "products-module--tiles--31207";
export var title = "products-module--title--97de8";